<article>
    <div class="container">
            <div class="path">
                <div class="text">알림 > 작성하기 > 미리보기</div>
                <button (click)="unactivePreivew()">닫기</button>
            </div>
            <h1 class="h1">알림</h1>
        <div class="list-detail">
            <div class="noticeTitle">
                <h2>{{notice.title}}</h2>
                <div class="button">
                    <button class="list">
                        <a >목록으로</a>
                    </button>
                    <button class="apply">
                        <a >지원하기</a>
                    </button>
                </div>
            </div>
            <div class="contents">
                <div class="date">
                    <p>등록일</p>
                    <p>{{date |date: "yyyy-MM-dd"}}</p>
                </div>
                <img src="/assets/images/recruitDetail.png">
                <div class="table">
                    <table>
                        <tr>
                            <th scope="row">내용</th>
                            <td >
                                <li *ngFor="let content of contents" id="content" [innerHtml]="content"> · </li>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">첨부파일</th>
                            <td >
                                <li *ngFor="let file of files"> · {{file}}</li>
                            </td>
                        </tr>

                    </table>

                </div>
            </div>
        </div>
    </div>
</article>